import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {PageContent} from "../Layout";
import {Col, Row} from "reactstrap";
import {api} from "../../api";
import {IWindow} from "../../index";
import {enums} from "../../Enums";
import _ = require("lodash");

const IWindow: IWindow = (window as IWindow);

export class ElectionPollingUnitDetailFormData {
    @observable id = IWindow.initialState.route.params.id;
    @observable number_of_votes = 0;
    @observable candidate_name = null;
    @observable polling_unit_name = null;
    @observable position = null;
    @observable election_name = null;
    @observable party_name = null;
    @observable state_name = null;
    @observable ward_name = null;
    @observable created_by = null;
    @observable created_at = null;
    @observable result_updated = null;
    @observable accredited_voters = null;
    @observable registered_voters = null;
    @observable documents = null;
    @observable showDocuments = null;
    @observable check_lists = null;
}

export class ElectionPollingUnitDetailForm extends CrudForm {
    modelName = 'ElectionPollingUnitDetail';
    icon = '';
    showSubmitButton = false;

    @observable accredited_voters = {
        accredited_voters: 0,
        registered_voters: 0,
        disputed_voters: 0,
        rejected_voters: 0,
        user_defined_1: 0,
        user_defined_2: 0,
        verified_voters_from_cr: 0,
    };

    getData = async () => {
        await api.partyElectionPollingUnit.getDetailAction(this.formStore.getValue('id')).then((data: any) => {
            this.formStore.setData(data.data);
            this.formStore.setValue('polling_unit_name', data.data.polling_unit.name);
            this.formStore.setValue('election_name', data.data.election.name);
            this.formStore.setValue('state_name', data.data.polling_unit.state.name);
            this.formStore.setValue('ward_name', data.data.polling_unit.ward.name);
            this.formStore.setValue('lga_name', data.data.polling_unit.local_government_area.name);
            this.formStore.setValue('accredited_voters',  (data.data.accredited_voters ? data.data.accredited_voters.accredited_voters : 0));
            this.formStore.setValue('registered_voters',   data.data.registered_voters);
            this.formStore.setValue('check_lists', data.data.check_lists);
            this.formStore.setValue('number_of_votes', 0);
            this.entity = data.data;
            if(data.data.accredited_voters){
                this.accredited_voters =  data.data.accredited_voters;
            }
        });
        this.isLoading = false;
    };

    renderDocument(document: any) {
        switch (document.file_type) {
            case 'image':
                this.icon = 'icon-image';
                break;

            case 'document':
                this.icon = 'icon-pdf';
                break;

            case 'audio':
                this.icon = 'icon-speaker';
                break;

            case 'video':
                this.icon = 'icon-play-button';
                break;
        }

        return (
            <div className="form-group" key={document.id}>
                <a href={document.url} target='_blank'>
                    <span className={this.icon} /> {document.title}
                </a>
            </div>
        );
    };

    renderCheckList(item:any) {
        return (
            <tr key={item.check_list_id}>
                <td>{item.title}</td>
                <td>{enums.checkListSubType[item.sub_type]}</td>
                <td><span
                    className={"ml-auto " + (item.is_completed ? 'icon-tick' : 'icon-close')}/></td>
                <td>
                    {this.renderContent(item)}
                </td>
            </tr>
        );
    }

    renderContent(item:any) {

        if (item.sub_type == 'entry') {
            return this.accredited_voters[item.entry_type] ? this.accredited_voters[item.entry_type] : '';
        }  else if (item.sub_type == 'other') {
            return item.remarks;
        } else if (item.sub_type == 'yes_no') {
            return <div>
                {item.yes_no ? "Yes" : "No"}
                <div>{item.remarks}</div>
            </div>;
        } else if (item.sub_type == 'yes_no') {
            return <div>
                {item.yes_no ? "Yes" : "No"}
                <div>{item.remarks}</div>
            </div>;
        } else if (item.sub_type == 'audio' || item.sub_type == 'document' || item.sub_type == 'video' || item.sub_type == 'image') {
            let document  = _.findLast(this.formStore.getValue('documents'), ['check_list_id', item.check_list_id]) || null;
            if(document && document.url){
                return <a href={document.url}  download>Download</a>
            }
            return "";
        }

        return "";
    };


    renderFields() {
        return (
            <>

                <Row className="form-row">
                    <Col md={6}>
                        <label className={'font-weight-bold text-primary'}>{this.formStore.getValue('polling_unit_name')}</label>
                    </Col>
                </Row>

                <Row className="form-row">
                    <Col md={6}>
                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Polling Unit</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('polling_unit_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>Ward</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('ward_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>LGA</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('lga_name')}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-row">
                            <Col md={12}>
                                <div className={'form-group'}>
                                    <div className={'font-weight-bold'}>State</div>
                                    <div className={'text-primary'}>{this.formStore.getValue('state_name')}</div>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col md={6}>
                        <div className={'font-weight-bold form-group'}>Uploaded files</div>
                        {
                            this.formStore.getValue('documents').map((document: any) => {
                                return this.renderDocument(document);
                            })
                        }
                    </Col>
                </Row>

                <Row className="form-row">
                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Number of Votes</div>
                            <div className={'text-primary'}>{this.formStore.getValue('number_of_votes')}</div>
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Accredited Voters</div>
                            <div className={'text-primary'}>{this.formStore.getValue('accredited_voters')}</div>
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Registered Voters</div>
                            <div className={'text-primary'}>{this.formStore.getValue('registered_voters')}</div>
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Pu. Reg. Voters</div>
                            <div className={'text-primary'}>{this.accredited_voters.registered_voters}</div>
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Disputed Voters</div>
                            <div className={'text-primary'}>{this.accredited_voters.disputed_voters}</div>
                        </div>
                    </Col>

                    <Col md={2}>
                        <div className={'form-group'}>
                            <div className={'font-weight-bold'}>Rejected Voters</div>
                            <div className={'text-primary'}>{this.accredited_voters.rejected_voters}</div>
                        </div>
                    </Col>

                </Row>

                {this.formStore.getValue('check_lists') ? <br/> : '' }
                {this.formStore.getValue('check_lists') ?
                    <div className="d-flex flex-column">
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row">
                                    <div className="col-xl-12 dash-sep-xl-right">
                                        <h6 className="light-subheading text-center text-uppercase my-3">Check Lists</h6>
                                        <div className="table-responsive">
                                            <table className="grid table table-hover">
                                                <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Type</th>
                                                    <th>Is Completed</th>
                                                    <th>Content</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.formStore.getValue('check_lists').map((checkList: any) => {
                                                        return this.renderCheckList(checkList);
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ''}
            </>
        );
    }
}

export class ElectionPollingUnitDetailPage extends React.Component {
    modelName = 'ElectionPollingUnitDetail';

    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <>
                <PageContent>
                    <ElectionPollingUnitDetailForm />
                </PageContent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPollingUnitDetailPage.tsx